import React, { Component } from 'react';

export default class ContactUs extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="contact">
			<div className="row section-head">
				<div className="two columns header-col">
					<h1><span>Entrer en contact</span></h1>
				</div>
         
				<div className="ten columns">
					<p className="lead">
					N'hésitez pas à me contacter pour toute information complémentaire.
					</p>
				</div>
			</div>
			
			<div className="row">
			  <div className="eight columns">				
				<form action method="post" id="contactForm" name="contactForm">
					<fieldset>
						<div>
						  <label htmlFor="contactName">Name <span className="required">*</span></label>
						  <input type="text" size={35} id="contactName" name="contactName" placeholder="Enter your name"/>
						</div>
						
						<div>
						  <label htmlFor="contactEmail">Email <span className="required">*</span></label>
						  <input type="text" size={35} id="contactEmail" name="contactEmail" placeholder="Enter your email"/>
						</div>
						
						<div>
						  <label htmlFor="contactSubject">Subject</label>
						  <input type="text" size={35} id="contactSubject" name="contactSubject" placeholder="Enter your subject"/>
						</div>
												
						<div>
						  <label htmlFor="contactMessage">Message <span className="required">*</span></label>
						  <textarea cols={50} rows={15} id="contactMessage" name="contactMessage" placeholder="Enter your message" />
						</div>
						
						<div>
						  <button className="submit">Submit</button>
						  <span id="image-loader">
							<img alt src="images/loader.gif" />
						  </span>
						</div>
				  </fieldset>
				</form> 
				
				<div id="message-warning">Error</div>			   
					<div id="message-success">
					  <i className="fa fa-check" />Your message was sent, thank you!<br />
					</div>
				</div>
				
				 <aside className="four columns footer-widgets">
					<div className="widget widget_contact">
						<h4>Address and Phone</h4>
						<p className="address">
						Cassano Gabriele
						<br />
						Rue Saint-Alphonse, 180
						<br />
						7110 Strépy-Bracquegnies<br />
						<span>0497/62.10.10</span>
					  </p>
					</div>
					
					<div className="widget widget_tweets">
						<h4 className="widget-title">My achievements</h4>
						<ul id="twitter">
							<li>
								<span>
								You find all my achievements on my updated professional profile website.
								<br/>
								<a href="http://profilprofessionnel.com/">&copy; Cassano Gabriele</a>
								</span>
								<b><a href="#">A week ago</a></b>
						</li>						
					  </ul>
					</div>
				  </aside>
			</div>
		</section>		  
	  }   
      </React.Fragment>
    );
  }
}
